import { createReducer, createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  setCreditData: ["creditData"],
  setInvestorData: ["investorData"],
  startCreditCreate: ["data"],
  startInvestorCreate: ["data"],
  startRetryPaymentCreate: ["data"],
  getTrackingACC: ["id"],
  downloadAmortizationTable: ["id"],
  urlDownload: ["urlDownload"],
  eraseData: [""],
  setErrorDownloadTA: ["isError"],
});

export const AccTypes = Types;
export default Creators;

export const INITIAL_STATE = {
  isFetching: false,
  data: "",
  campaingData: "",
  response: "",
  creditData: {},
  isErrorDownloadTA: false,
  investorData: {}
};

const setCreditData = (state, { creditData }) => {
  const stateCreditData = state.creditData;
  return Object.assign({}, state, {
    isFetching: false,
    creditData: { ...stateCreditData, ...creditData },
  });
};

const setInvestorData = (state, { investorData }) => {
  const stateCreditData = state.creditData;
  return Object.assign({}, state, {
    isFetching: false,
    creditData: { ...stateCreditData, ...investorData },
  });
};

const urlDownload = (state, { urlDownload }) =>
  Object.assign({}, state, {
    isFetching: false,
    urlDownload,
  });

const startCreditCreate = (state) =>
  Object.assign({}, state, {
    isFetching: true,
    response: "",
  });

const startInvestorCreate = (state) =>
  Object.assign({}, state, {
    isFetching: true,
    response: "",
  });

const startRetryPaymentCreate = (state) =>
  Object.assign({}, state, {
    isFetching: true,
    response: "",
  });

const getTrackingACC = (state) =>
  Object.assign({}, state, {
    isFetching: true,
    response: "",
  });

const downloadAmortizationTable = (state) =>
  Object.assign({}, state, {
    isFetching: true,
    response: "",
  });

const eraseData = (state) =>
  Object.assign({}, state, {
    creditData: {},
    isErrorDownloadTA: false,
  });

const setErrorDownloadTA = (state, { isError }) =>
  Object.assign({}, state, {
    isErrorDownloadTA: isError,
  });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_CREDIT_DATA]: setCreditData,
  [Types.SET_INVESTOR_DATA]: setInvestorData,
  [Types.URL_DOWNLOAD]: urlDownload,
  [Types.START_CREDIT_CREATE]: startCreditCreate,
  [Types.START_INVESTOR_CREATE]: startInvestorCreate,
  [Types.START_RETRY_PAYMENT_CREATE]: startRetryPaymentCreate,
  [Types.GET_TRACKING_ACC]: getTrackingACC,
  [Types.DOWNLOAD_AMORTIZATION_TABLE]: downloadAmortizationTable,
  [Types.ERASE_DATA]: eraseData,
  [Types.SET_ERROR_DOWNLOAD_TA]: setErrorDownloadTA,
});
